<div *ngIf="visible" class="change-locker-button-container">
  <a type="button" (click)="onClick()">
    <div class="image-container" [inlineSVG]='"/static/images/svg/change_locker.svg"'>
    </div>
  </a>
</div>
